import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
import Select from 'react-select';
import { Post } from '../../../../function/Koneksi';

const ModalPenomoranSurat = ({ data, optionData, setAlert, isOpen, setIsOpen, setStatusRefresh}) => {

	const frmDex = {
		uuid: "",
		uuid_jenis_surat: "",
		layanan_apm: 0,
		layanan_bo: 0,
		layanan_mobile: 0,
		cetak_layanan_kiosk: 0,
		nomor_surat: "",
		jenis_penduduk: "",
		status_ttd_bsre: 0,
	}

	const initFormData = {
		jenisSuratDetail: optionData.jenisSuratDetail,
		formJenisPenduduk: optionData.formJenisPenduduk,
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		
		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			status: optionData.status,
		} : initFormData)
	}, [isOpen])

	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const changeSelectValue = (e, dtVal) => {
		if(e){
			if(dtVal === 'layanan_apm'){
				if(e.value === 0){
					setDt({
						...dt,
						[dtVal]: e,
						cetak_layanan_kiosk: e,
					})
				}
				else{
					setDt({
						...dt,
						[dtVal]: e,
					})
				}
			}
			else{
				setDt({
					...dt,
					[dtVal]: e,
				})
			}
		}
		else{
			setDt({
				...dt,
				[dtVal]: '',
			})
		}
	};

	const simpan = (e) => {
		e.preventDefault();
		setAlert({
			loadingPreview: true
		})

		if(
			dt.layanan_apm.value === undefined ||
			dt.layanan_bo.value === undefined ||
			dt.layanan_mobile.value === undefined ||
			dt.cetak_layanan_kiosk.value === undefined ||
			dt.jenis_penduduk.value === undefined ||
			dt.status_ttd_bsre.value === undefined
		){
			setAlert({
				loadingPreview: false
			})

			const alertData = {
				show: true,
				basicType: "warning",
				basicTitle: "Konfigurasi " + formData.jenisSuratDetail.nama_surat,
				pesanAlert: "Data Tidak Lengkap!"
			}
			setAlert(alertData)
		}
		else{
			let bodyRaw = {
				...dt,
				uuid_jenis_surat: formData.jenisSuratDetail.uuid,
				layanan_apm: dt.layanan_apm.value,
				layanan_bo: dt.layanan_bo.value,
				layanan_mobile: dt.layanan_mobile.value,
				cetak_layanan_kiosk: dt.cetak_layanan_kiosk.value,
				jenis_penduduk: dt.jenis_penduduk.value,
				status_ttd_bsre: dt.status_ttd_bsre.value,
			}
	
			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}
			
			Post("pengaturan-surat/" + metode, bodyRaw.uuid, bodyRaw,res => {
				setFormData({
					...formData,
					status: {
						...formData.status,
						btnForm: false,
						form: false,
					}
				})
				setIsOpen(false)
				if (res.status === resstat) {
					setAlert({
						loadingPreview: false
					})
	
					const alertData = {
						show: true,
						basicType: "success",
						basicTitle: "Konfigurasi " + formData.jenisSuratDetail.nama_surat,
						pesanAlert: "Berhasil " + psn + " Data",
						successAlert: true,
					}
					setAlert(alertData)
				} else {
					setAlert({
						loadingPreview: false
					})
	
					const alertData = {
						show: true,
						basicType: "danger",
						basicTitle: "Konfigurasi " + formData.jenisSuratDetail.nama_surat,
						pesanAlert: "Gagal " + psn + " Data"
					}
					setAlert(alertData)
				}
	
				// Refresh list
				setStatusRefresh(true)
			});
		}
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={true}
			styles={{ modal: { width: '70%', maxWidth: 'unset' } }}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Konfigurasi {formData.jenisSuratDetail ? formData.jenisSuratDetail.nama_surat:''}</h5>
				</div>
				<div className="modal-body">
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>
					<FormGroup className="row">
						<Col sm="6">
							<Label
							className="col-form-label"
							htmlFor="inputEmail3"
							>
								<b>Format Penomoran Surat</b>
							</Label>
							<input
								data-testid="nomor_surat"
								name="nomor_surat"
								className="form-control"
								id="nomor_surat"
								type="text"
								placeholder="Masukkan nomor urut surat"
								defaultValue={dt.nomor_surat}
								required
								onChange={e => changeInputText(e, "nomor_surat")}
							/>
						</Col>
						<Col sm="6">
							<Label
							className="col-form-label"
							htmlFor="inputEmail3"
							>
								<b>Jenis Penduduk Yang Mengajukan</b>
							</Label>
							<Select
								classNamePrefix="select"
								onChange={e => {
									changeSelectValue(e,'jenis_penduduk');
								}}
								defaultValue={dt.jenis_penduduk}
								value={dt.jenis_penduduk}
								name="jenis_penduduk"
								options={formData.formJenisPenduduk}
								placeholder="Pilih Jenis Penduduk"
								isClearable
							/>
						</Col>
						<Col sm='6'>
							<Label className="col-form-label" htmlFor="inputEmail3">
								<b>Status Layanan APM</b>
							</Label>
							<Select
								classNamePrefix="select"
								onChange={ e => {
									changeSelectValue(e, 'layanan_apm');
								}}
								value={dt.layanan_apm}
								name="layanan_apm"
								options={[
									{ value: 1, label: 'Aktif' },
									{ value: 0, label: 'Tidak Aktif' },
								]}
								placeholder="Pilih Status Layanan APM"
								isClearable
							/>
						</Col>
						<Col sm='6'>
							<Label className="col-form-label" htmlFor="inputEmail3">
								<b>Status Cetak Layanan APM</b>
							</Label>
							<Select
								classNamePrefix="select"
								onChange={ e => {
									changeSelectValue(e, 'cetak_layanan_kiosk');
								}}
								value={dt.cetak_layanan_kiosk}
								name="cetak_layanan_kiosk"
								options={[
									{ value: 1, label: 'Aktif' },
									{ value: 0, label: 'Tidak Aktif' },
								]}
								placeholder="Pilih Status Cetak Layanan APM"
								isClearable
								isDisabled={dt.layanan_apm && dt.layanan_apm.value === 0 ? true : false}
							/>
						</Col>
						<Col sm='6'>
							<Label className="col-form-label" htmlFor="inputEmail3">
								<b>Status Layanan BO</b>
							</Label>
							<Select
								classNamePrefix="select"
								onChange={ e => {
									changeSelectValue(e, 'layanan_bo');
								}}
								value={dt.layanan_bo}
								name="layanan_bo"
								options={[
									{ value: 1, label: 'Aktif' },
									{ value: 0, label: 'Tidak Aktif' },
								]}
								placeholder="Pilih Status Layanan BO"
								isClearable
							/>
						</Col>
						<Col sm='6'>
							<Label className="col-form-label" htmlFor="inputEmail3">
								<b>Status Layanan Mobile</b>
							</Label>
							<Select
								classNamePrefix="select"
								onChange={ e => {
									changeSelectValue(e, 'layanan_mobile');
								}}
								value={dt.layanan_mobile}
								name="layanan_mobile"
								options={[
									{ value: 1, label: 'Aktif' },
									{ value: 0, label: 'Tidak Aktif' },
								]}
								placeholder="Pilih Status Layanan Mobile"
								isClearable
							/>
						</Col>
						<Col sm='6'>
							<Label className="col-form-label" htmlFor="inputEmail3">
								<b>Status TTD Bsre</b>
							</Label>
							<Select
								classNamePrefix="select"
								onChange={ e => {
									changeSelectValue(e, 'status_ttd_bsre');
								}}
								value={dt.status_ttd_bsre}
								name="status_ttd_bsre"
								options={[
									{ value: 1, label: 'Aktif' },
									{ value: 0, label: 'Tidak Aktif' },
								]}
								placeholder="Pilih Status TTD Bsre"
								isClearable
							/>
						</Col>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							// Tutup modal
							setFormData({
								...formData,
								status: {
									...formData.status,
									form: false,
								}
							})
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalPenomoranSurat;
